import { render, staticRenderFns } from "./index-new.vue?vue&type=template&id=576154dc&scoped=true"
import script from "./index-new.vue?vue&type=script&lang=js"
export * from "./index-new.vue?vue&type=script&lang=js"
import style0 from "./index-new.vue?vue&type=style&index=0&id=576154dc&prod&lang=less&scoped=true"
import style1 from "./index-new.vue?vue&type=style&index=1&id=576154dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576154dc",
  null
  
)

export default component.exports